import React from 'react';
import {Controller} from 'react-hook-form';
import {useQuery} from 'react-query';
import Select from 'react-select';
import {get} from '../../service/ApiService';
import {Region} from '../../service/Urls';
import {Box, Flex, FormLabel, Text} from '@chakra-ui/react';

export default function RegionSelectNew({
  control,
  name,
  isReadOnly,
  required,
  setCode,
}: {
  control: any;
  name: string;
  isReadOnly?: boolean;
  required?: boolean;
  setCode?: (code: number) => void;
}) {
  const {data} = useQuery('regions', () => get(Region.DROPDOWN + '?PageSize=' + 10000));

  const regions =
    data?.data?.map(region => ({
      value: region?.id,
      label: `${region?.code} - ${region?.name}`,
    })) ?? [];

  return (
    <Controller
      name={name}
      control={control}
      rules={{required}}
      render={({field: {value, onChange, ...rest}, fieldState: {error}}) => {
        return (
          <Flex mx={1}>
            <Box w="100%">
              <FormLabel fontSize="sm" mb="-0.5" ml="1">
                Select Region
              </FormLabel>
              <Select
                {...rest}
                value={regions?.find(region => region.value === value) ?? null}
                onChange={(newValue, actionMeta) => {
                  if (setCode) {
                    const regionCode = newValue?.label?.split(' ')[0];
                    setCode(regionCode);
                  }

                  onChange(newValue?.value, actionMeta);
                }}
                options={regions}
                isDisabled={isReadOnly}
              />

              {error && (
                <Text color="red.400" fontSize="sm">
                  * Region is required
                </Text>
              )}
            </Box>
          </Flex>
        );
      }}
    />
  );
}
